const Sklad = () => {
    return (
        <section className="flex flex-row items-center w-full justify-center mq450:h-auto bg-white">
        <div id="sklad" className="flex flex-col max-w-[1280px] w-full justify-between px-[24px] gap-[80px] mq450:px-4  mq450:gap-[48px] h-full py-[96px] mq450:py-[32px]">
        <div id="top" className="flex flex-row mq450:flex-col gap-[64px] mq450:gap-[24px] justify-center items-end">
            <div id="left" className="flex flex-col w-full gap-[12px]">
                <div id="title" className='font-silka-semibold font-[600] text-[16px] leading-[130%] text-[#362F5B] mq450:text-[14px] uppercase'>SKŁAD</div>
                <div id="subtitle" className='font-silka-semibold font-[600] text-[40px] leading-[130%] text-[#362F5B] mq450:text-[24px]'>Skład i bezpieczeństwo</div>
            </div>
            <div id="right" className="w-auto">
            <div id='text' className='text-[18px] font-silka-semibold font-[300] text-[#362F5B]'>W Evera wierzymy, że świadome wybory zaczynają się od pełnej informacji. Dlatego nasze suplementy tworzymy według najwyższych standardów jakości i przejrzystości.</div>
            </div>
        </div>
        
        <div id="content" className="flex flex-row w-full gap-[64px] mq450:gap-[48px] mq450:flex-col">
        <div id="column" className="flex flex-col w-full gap-[48px] mq450:gap-[32px]">
            <div className="flex flex-row items-center gap-[24px]">
                <img src="/check-icon.svg" />
                <div id="text" className="flex flex-col gap-[12px]">
                    <div id="title" className="text-[18px] font-silka-semibold font-[500] text-[#362F5B]">Każdy składnik przebadany klinicznie</div>
                    <div id="subtitle" className="text-[18px] font-silka-semibold font-[300] text-[#362F5B] mq450:text-[16px]">Stosujemy wyłącznie składniki aktywne, których działanie potwierdzono w badaniach naukowych. Formuły opracowywane są we współpracy ze specjalistami z dziedziny dietetyki i fitoterapii.</div>
                </div>
            </div>
            <div id="line" className="flex w-full h-[1px] bg-[#362F5B]"></div>
            <div className="flex flex-row items-center gap-[24px]">
                <img src="/check-icon.svg" />
                <div id="text" className="flex flex-col gap-[12px]">
                    <div id="title" className="text-[18px] font-silka-semibold font-[500] text-[#362F5B]">Bez GMO, glutenu, cukru i alergenów</div>
                    <div id="subtitle" className="text-[18px] font-silka-semibold font-[300] text-[#362F5B] mq450:text-[16px]">Nasze żelki są odpowiednie dla osób na dietach eliminacyjnych, wegan i wegetarian. Nie zawierają składników modyfikowanych genetycznie, glutenu, sztucznego cukru ani typowych alergenów.</div>
                </div>
            </div>
            <div id="line" className="flex w-full h-[1px] bg-[#362F5B]"></div>
            <div className="flex flex-row items-center gap-[24px]">
                <img src="/check-icon.svg" />
                <div id="text" className="flex flex-col gap-[12px]">
                    <div id="title" className="text-[18px] font-silka-semibold font-[500] text-[#362F5B]">Produkowane zgodnie z najwyższymi standardami jakości (GMP)</div>
                    <div id="subtitle" className="text-[18px] font-silka-semibold font-[300] text-[#362F5B] mq450:text-[16px]">Cały proces produkcyjny odbywa się w certyfikowanych zakładach przestrzegających zasad Dobrej Praktyki Wytwarzania (Good Manufacturing Practice), co gwarantuje czystość, bezpieczeństwo i skuteczność każdego produktu.</div>
                </div>
            </div>
        </div>
        <img src="/sklad-img.svg" className="flex w-full mq450:hidden"/>
        <img src="/sklad-img-mobile.svg" className="hidden mq450:flex w-full"/>


        </div>

        </div>
      </section>
    );
  };
  
  export default Sklad;
  